export default __webpack_public_path__ + "static/media/17_photo.506bf7df.jpg";